import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
} from '@tonic-one/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import LoadingBtn from '../LoadingBtn';

export default function DelModal(props: any) {
  const {
    visible,
    onClose,
    onConfirm,
    loading = false,
    title,
    content,
    children,
    withEditPermission,
  } = props;
  const { t } = useTranslation();

  const useToggle = (defaultValue: boolean) => {
    const [value, setValue] = useState(defaultValue);
    const toggle = () => setValue((value) => !value);
    return [value, toggle];
  };

  const [isOverlayVisible] = useToggle(true);

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={visible}
      onClose={onClose}
      size="md"
    >
      {isOverlayVisible && <ModalOverlay opacity={0.9} />}
      <ModalContent>
        <ModalHeader>{title || ''}</ModalHeader>
        <ModalBody>
          <Text mb="8x">{content || children}</Text>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn
            variant="primary"
            minWidth="20x"
            loading={loading}
            onClick={onConfirm}
            disabled={!withEditPermission}
          >
            {t('reportCommon.buttons.delete')}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('reportCommon.buttons.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
